import type { SupportedLocale } from '../config/localeConfig';
import { LOCALE_FALLBACKS } from '../config/localeFallbacks';

export type LocalizedField<T = string> = Partial<Record<SupportedLocale, T>>;

export function getLocalizedValue<T>(
  field: LocalizedField<T> | undefined | null,
  locale: SupportedLocale
): T | undefined {
  if (!field) return undefined;

  const chain = LOCALE_FALLBACKS[locale] || ['en'];

  for (const candidate of chain) {
    const value = field[candidate];
    if (value !== undefined && value !== null && value !== '') {
      return value;
    }
  }

  return undefined;
}
